<template>
  <div>
      <el-form :model="formData" ref="form" label-suffix="：">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="验收结果"> {{ formData.status === 1 ? '达标' : '不达标' }} </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="验收时间">
              {{ formData.inspectionDateTime ? parseTime(formData.inspectionDateTime, '{y}-{m}-{d} {h}:{i}') : '-' }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="工厂核验总筐数"> {{ formData.totalApprovedQuantity || '-' }} </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="工厂核验总净重（斤）"> {{ formData.totalApprovedNetWeight || '-' }} </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="总净重差值（斤）">{{ myFixed(formData.totalApprovedNetWeight - formData.totalNetWeight, 2) || '-'  }} </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="不达标总净重（斤）"> {{ formData.notStandardNetWeight || '-' }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="结算总净重（斤）"> {{ formData.totalSettlementNetWeight || '-' }} </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注"> {{ formData.remark || '-' }} </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="gap">
        <ReceiptTable :check-items="formData.checkItems" style="width: 70%" />
      </div>
  </div>
</template>

<script>

import ReceiptTable from './ReceiptTable.vue'

export default {
  name: 'ReceiptResult',
  components: {
    ReceiptTable,
  },
  props: {
    formData: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      
    }
  },
  mounted() {
    
  },
  methods: {
  
  },
}
</script>

<style scoped lang="less">

.gap {
  margin-bottom: 30px;
}

::v-deep {
  .el-form-item {
    margin-bottom: 0;
  }
  .el-form-item__label {
    color: #000;
  }
}

</style>
